import { v4 as uuidv4 } from 'uuid';
import { omit, isPlainObject, camelCase, get } from 'lodash';

import * as ValidLayoutTypes from 'APP_ROOT/constants/layoutComponentTypes';

export default class FormComponent {
  constructor(type, options, properties) {
    const formComponent = {
      id: uuidv4(),
    };

    if (ValidLayoutTypes.SECTION === type) {
      formComponent.columns = 2;
    }

    if (isPlainObject(options)) {
      Object.entries(
        omit(options, ['properties', 'type', 'isCopy', 'select', 'id'])
      ).forEach(([key, value]) => {
        formComponent[key] = value;
      });
    }

    const rnd = Math.trunc(Math.random() * 1000);
    const title = get(options, 'title', '');
    const reporting = get(options, 'field_type', type);
    const reportingKey = get(
      options,
      'reportingKey',
      options?.isCopy
        ? `${camelCase(reporting)}-${rnd}`
        : `${camelCase(title || reporting) + rnd}`
    );
    formComponent.reportingKey = reportingKey;

    if (Object.values(ValidLayoutTypes).includes(type)) {
      formComponent.type = type;
    }

    if (Array.isArray(properties)) {
      formComponent.properties = properties;
    }

    if (options?.conditions) {
      formComponent.conditions = options.conditions;
    }

    if (options?.math) {
      formComponent.math = options.math;
    }

    return formComponent;
  }
}
